module.exports = __webpack_public_path__ + "img/tui1.c1bd77b4.png";